import { render, staticRenderFns } from "./CustomStatCardChart.vue?vue&type=template&id=6b5835f7&scoped=true&"
import script from "./CustomStatCardChart.vue?vue&type=script&lang=ts&"
export * from "./CustomStatCardChart.vue?vue&type=script&lang=ts&"
import style0 from "./CustomStatCardChart.vue?vue&type=style&index=0&id=6b5835f7&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b5835f7",
  null
  
)

export default component.exports